/**
 * @Description 授权接口
 */
import { _post } from '@/common/request';
/**
 * 获取授权版本弹窗
 * https://yapi.lanhanba.com/project/319/interface/api/58988
 */
export function getVisionAuthMessage() {
    return _post("/property/userMessage/alert", {}, true);
}
